<template>
  <div v-if="page.career" class="page page-dark page-career">
    <div class="container">

      <div class="col-md-12">
        <div v-html="page.career.text_lead_dark" class="lead lead-intro col-md-12"/>
        <h1>{{ page.career.name }}</h1>
      </div>


      <div class="col-md-12 career-growth">
        <div class="career-growth-desc" v-html="page.career.text_main_career_dark"/>
        <div class="page-career--switcher uppercase font-grotesque">
          <p @click="changeSlide(key)" v-html="page.career[`text_switcher_0${key+1}_dark`]" v-for="name, key in switchers()" :class="`page-career--switch page-career--switch-${key === careerSlide ? 'active' : ''}`"/>
        </div>
        <div v-if="key == careerSlide" v-html="page.career[`text_stage_dark_0${key+1}`]" v-for="stage, key in stages()" class="page-career--stages"/>
      </div>

      <div class="container">
        <div class="page-career--man">
          <div :class="`page-career--man-body page-career--man-body-${careerSlide === 0 ? 'active' : ''}`">
            <img src="/static/career/career-student-dark.svg"/>
          </div>
          <div :class="`page-career--man-body page-career--man-body-${careerSlide === 1 ? 'active' : ''}`">
            <img src="/static/career/career-spec-dark.svg"/>
          </div>
          <div :class="`page-career--man-body page-career--man-body-${careerSlide === 2 ? 'active' : ''}`">
            <img src="/static/career/career-pro-dark.svg"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'career',
  computed: mapGetters({
    careerSlide: 'careerSlide',
    page: 'page',
  }),
  methods: {
    stages() {
      const stages = Object.keys(this.page.career).filter(key => key.indexOf('text_stage_dark_0') > -1);
      return stages;
    },
    switchers() {
      const stages = Object.keys(this.page.career).filter(key => key.indexOf('text_switcher_0') > -1);
      return stages;
    },
    changeSlide(key) {
      this.$store.commit('CAREER_SLIDE', key);
    },
  },
};
</script>


<style>
.page-career{
  &.page-dark{
    .page-career--switch{
      border-bottom-color: rgba(255,255,255,.3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CareerDark.vue